import script from "./MangaTranslationVip.vue?vue&type=script&setup=true&lang=js"
export * from "./MangaTranslationVip.vue?vue&type=script&setup=true&lang=js"

import "./MangaTranslationVip.vue?vue&type=style&index=0&id=c13690c2&scoped=true&lang=css"
import "./MangaTranslationVip.vue?vue&type=style&index=1&id=c13690c2&lang=css"
import "./MangaTranslationVip.vue?vue&type=style&index=2&id=c13690c2&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c13690c2"]])

export default __exports__